module.exports = __webpack_public_path__ + "static/1-60f36a70f5071a7ec6a17849822efccd.svg";